import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  align-items: center;
  background: #f4f4f2;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #ddd;
  height: 36px;

  @media screen and (max-width: 800px) {
    display: none;
  }
`;

export const Input = styled.input`
  border: none;
  background: transparent;
  padding: 0 12px;
  font-size: 14px;
  width: 220px;
  outline: none;
  color: #333;

  &::placeholder {
    color: #aaa;
  }
`;

export const Button = styled.button`
  background: var(--primary);
  border: none;
  color: #fff;
  padding: 0 12px;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;

  &:hover {
    opacity: 0.9;
  }
`;
